import React, { useState, useEffect } from "react";
import api from "../../../services/api";

export default function TokenManagement() {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);

  const [issuedTo, setIssuedTo] = useState("");
  const [expiresAt, setExpiresAt] = useState("");

  const [toast, setToast] = useState("");        // 🔥 уведомление
  const [confirmDelete, setConfirmDelete] = useState(null); // 🔥 модалка удаления

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 1500);
  };

  // формат даты
  const formatDate = (d) => {
    if (!d) return "Без срока";
    return new Date(d).toLocaleDateString("ru-RU");
  };

  const fetchTokens = async () => {
    try {
      setLoading(true);
      const data = await api.get("/externaltokens/getall");
      setTokens(data);
    } catch (err) {
      console.error("Ошибка загрузки:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  const createToken = async () => {
    if (!issuedTo.trim()) return alert("Введите, кому выдать");

    try {
      await api.post("/externaltokens/create", {
        issuedTo,
        expiresAt: expiresAt || null,
        purpose: "document_sync",
      });

      setIssuedTo("");
      setExpiresAt("");
      fetchTokens();
    } catch (err) {
      console.error("Ошибка создания:", err);
    }
  };

  const deleteToken = async () => {
    if (!confirmDelete) return;

    try {
      await api.delete(`/externaltokens/${confirmDelete}`);
      setTokens((p) => p.filter((t) => t.id !== confirmDelete));
      setConfirmDelete(null);
    } catch (err) {
      console.error("Ошибка удаления:", err);
    }
  };

  const copyLink = async (text, who) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        // fallback для HTTP
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      showToast(`Ссылка для "${who}" скопирована`);
    } catch (err) {
      console.error("Ошибка копирования:", err);
      showToast("Не удалось скопировать");
    }
  };

  return (
    <div style={{ padding: "24px" }}>
      <h1 style={{ fontSize: "26px", marginBottom: "20px" }}>
        Управление токенами доступа
      </h1>

      {/* Форма */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "25px",
          flexWrap: "wrap",
        }}
      >
        <input
          type="text"
          placeholder="Кому выдать"
          value={issuedTo}
          onChange={(e) => setIssuedTo(e.target.value)}
          style={{
            padding: "10px 12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            flex: 1,
            minWidth: "180px",
          }}
        />

        <input
          type="date"
          value={expiresAt}
          onChange={(e) => setExpiresAt(e.target.value)}
          style={{
            padding: "10px 12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        />

        <button
          onClick={createToken}
          style={{
            padding: "10px 16px",
            background: "rgb(0, 125, 255)",
            color: "white",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          Выдать токен
        </button>
      </div>

      <h2 style={{ fontSize: "20px", marginBottom: "16px" }}>
        Список токенов
      </h2>

      {loading ? (
        <p>Загрузка...</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(330px, 1fr))",
            gap: "16px",
          }}
        >
          {tokens.map((t) => (
            <div
              key={t.id}
              style={{
                background: "#fff",
                padding: "16px",
                borderRadius: "10px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                border: "1px solid #f1f1f1",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <b style={{ fontSize: "1rem" }}>{t.issuedTo}</b>

              <div style={{ fontSize: "0.9rem", color: "#555" }}>
                Действует до: {formatDate(t.expiresAt)}
              </div>

              <div style={{ display: "flex", gap: "10px", marginTop: "6px" }}>
                <button
                  onClick={(e) => {
                    const btn = e.currentTarget;
                    btn.style.transform = "scale(0.92)";
                    setTimeout(() => {
                      btn.style.transform = "scale(1)";
                    }, 150);

                    copyLink(t.encryptedLink, t.issuedTo);
                  }}
                  style={{
                    flex: 1,
                    padding: "8px",
                    background: "rgb(0, 125, 255)",
                    color: "white",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: 600,
                    transition: "0.15s",
                  }}
                >
                  Копировать ссылку
                </button>

                <button
                  onClick={() => setConfirmDelete(t.id)}
                  style={{
                    padding: "8px",
                    background: "#e63946",
                    color: "white",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  Удалить
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 🔥 Модалка подтверждения удаления */}
      {confirmDelete && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px 25px",
              borderRadius: "8px",
              width: "300px",
              textAlign: "center",
            }}
          >
            <p style={{ marginBottom: "20px" }}>
              Удалить этот токен?
            </p>

            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={() => setConfirmDelete(null)}
                style={{
                  flex: 1,
                  padding: "8px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                Отмена
              </button>

              <button
                onClick={deleteToken}
                style={{
                  flex: 1,
                  padding: "8px",
                  background: "#e63946",
                  color: "white",
                  borderRadius: "6px",
                  border: "none",
                }}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔔 Тост */}
      {toast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#333",
            color: "white",
            padding: "10px 16px",
            borderRadius: "6px",
            fontSize: "0.9rem",
            opacity: toast ? 1 : 0,
            transition: "opacity 0.3s",
          }}
        >
          {toast}
        </div>
      )}
    </div>
  );
}
